/* eslint-disable no-console */
const LOGGING_LEVELS = Object.freeze({
  error: 'error',
  info: 'info',
  warn: 'warn',
});

const isLogsEnabled = import.meta.env.VITE_APP_LOGS_ENABLED === 'true';

const log = ({ level = LOGGING_LEVELS.error, logData, message, name, ...rest }) => {
  if (isLogsEnabled && (message || logData || rest)) {
    const data = {};
    if (logData) {
      data.logData = logData;
    }
    if (Object.keys(rest || {}).length > 0) {
      data.rest = rest;
    }
    if (Object.keys(data).length > 0) {
      console[level](`${name}${message ? ` - ${message}` : ''}`, data);
    } else {
      console[level](`${name}${message ? ` - ${message}` : ''}`);
    }
  } else {
    return;
  }
};

const logError = ({ logData, message, name, ...rest }) => {
  log({
    level: LOGGING_LEVELS.error,
    logData,
    message,
    name,
    ...rest,
  });
};

const logInfo = ({ logData, message, name, ...rest }) => {
  log({
    level: LOGGING_LEVELS.info,
    logData,
    message,
    name,
    ...rest,
  });
};

const logWarn = ({ logData, message, name, ...rest }) => {
  log({
    level: LOGGING_LEVELS.warn,
    logData,
    message,
    name,
    ...rest,
  });
};

export { isLogsEnabled, logError, logInfo, logWarn };
